import HolidaysGroupDashboardContainer from "~/pages/holidays"

export default HolidaysGroupDashboardContainer
